import {
  capitalize,
  unstable_composeClasses as composeClasses,
  generateUtilityClass,
  generateUtilityClasses
} from "@mui/material";
const actionBarName = "TidalActionBar";
function getActionBarUtilityClass(slot) {
  return generateUtilityClass(actionBarName, slot);
}
const actionBarClasses = generateUtilityClasses(actionBarName, [
  "root",
  "sizeTiny",
  "sizeSmall",
  "sizeMedium",
  "sizeLarge",
  "list",
  "listTextOnly",
  "listTextIcon",
  "listIconOnly",
  "menuButton",
  "menuTooltip",
  "menuTextOnly",
  "menuTextIcon",
  "menuIconOnly",
  "truncateList"
]);
function useUtilityClasses(ownerState) {
  const { size, menuMode, classes, listMode } = ownerState;
  const slots = {
    root: ["root", size && `size${capitalize(size)}`],
    list: ["list", menuMode && `menuMode${capitalize(menuMode)}`, listMode && `listMode${capitalize(listMode)}`],
    truncateList: ["truncateList"],
    menuButton: ["menuButton"],
    menuTooltip: ["menuTooltip"]
  };
  return composeClasses(slots, getActionBarUtilityClass, classes);
}
export {
  actionBarClasses,
  actionBarName,
  getActionBarUtilityClass,
  useUtilityClasses
};
//# sourceMappingURL=classes.js.map
